import { CopiedFromObjectLink } from '@/domain/interface/kopieer/CopiedFromObjectLink';

export class CopiedObjectRequest {
  copyFromId: string;

  constructor(copiedObjectLink: CopiedFromObjectLink) {
    this.copyFromId = copiedObjectLink.copyFromId;
  }
}
